import React from 'react';
import { Link } from 'react-router-dom';

export const FAQs = () => {
  return (
    <section className='bg-theme py-5'>
      <div className='container'>
        <h2 className='text-center text-white font-weight-bold mb-5'>FAQs</h2>
        <div className='row row-cols-1 row-cols-md-2'>
          <div className='col p-4'>
            <button
              type='button'
              className='btn h-100 w-100 text-left bg-white rounded-xl faqs-item p-3'
            >
              <h6 className='font-weight-bold mb-4'>
                What is Unusual Option Activity?
              </h6>
              <p className='h6 font-weight-light text-black-50'>
                Unusual Options Activity, also known as UOA, occurs when there
                is a large number of options traded for a given stock at an
                unusual rate. While there are lots of regular options trading
                that happens everyday. unusual options activity is when
                abnormally large options trades are made, usually as a large bet
                or for hedging...
              </p>
              <div className='mt-2 text-right'>
                <Link className='btn btn-sm btn-call rounded-pill px-3 text-white'>
                  <small className='text-uppercase font-weight-bold'>
                    Learn More
                  </small>
                </Link>
              </div>
            </button>
          </div>
          <div className='col p-4'>
            <button
              type='button'
              className='btn h-100 w-100 text-left bg-white rounded-xl faqs-item p-3'
            >
              <h6 className='font-weight-bold mb-4'>
                Can UOA data only be used for option trading?
              </h6>
              <p className='h6 font-weight-light text-black-50'>
                No, We personally used it for stock investment, not options. UOA
                data is an useful tool to understand the market sentiment and
                institution's big money option investment for any given stock.
                Pair with proper due diligence and analysis. it can greatly
                assist in predicting the price movement of a stock, and its
                derivative such as option...
              </p>
              <div className='mt-2 text-right'>
                <Link className='btn btn-sm btn-call rounded-pill px-3 text-white'>
                  <small className='text-uppercase font-weight-bold'>
                    Learn More
                  </small>
                </Link>
              </div>
            </button>
          </div>
          <div className='col p-4'>
            <button
              type='button'
              className='btn h-100 w-100 text-left bg-white rounded-xl faqs-item p-3'
            >
              <h6 className='font-weight-bold mb-4'>
                Why Unusual Option Activity matters?
              </h6>
              <p className='h6 font-weight-light text-black-50'>
                Unusual Options can provide insight on what "Smart Money" is
                doing with large volume orders, signaling new positions and
                potentially a big move in the underlying stock. UOA can be a
                great tool for idea generation so we can follow professional
                traders and identify stocks we otherwise wouldn't have
                notice.....
              </p>
              <div className='mt-2 text-right'>
                <Link className='btn btn-sm btn-call rounded-pill px-3 text-white'>
                  <small className='text-uppercase font-weight-bold'>
                    Learn More
                  </small>
                </Link>
              </div>
            </button>
          </div>
          <div className='col p-4'>
            <button
              type='button'
              className='btn h-100 w-100 text-left bg-white rounded-xl faqs-item p-3'
            >
              <h6 className='font-weight-bold mb-4'>
                How often does OptionFalcon update its data?
              </h6>
              <p className='h6 font-weight-light text-black-50'>
                OptionFalcon's algorithem scans the option market throughout the
                trading day, and upload the data to our database as soon as it
                is detected. Our historical database will updated in real time
                so you can compare and analzyze the data to its historical
                average.....
              </p>
              <div className='mt-2 text-right'>
                <Link 
                  className='btn btn-sm btn-call rounded-pill px-3 text-white'>
                  <small className='text-uppercase font-weight-bold'>
                    Learn More
                  </small>
                </Link>
              </div>
            </button>
          </div>
        </div>
        <div className='text-center mt-5'>
          <Link
            to="/report"
            type='button'
            className='btn btn-call btn-lg border-0 rounded-pill py-3 px-5 text-white font-weight-bolder'
          >
            <span>Learn how to analyze UOA data</span>
          </Link>
        </div>
      </div>
    </section>
  );
};
